import Label from "components/Label";
import { useTranslation } from "react-i18next";
import { mappedCustomerTypes } from "utils/contacts/mappedTs";
import type { CustomerType } from "../../../../../@types/sharedSchema";
import type { LabelColor } from "components/Label";

// Customer-TYPE chip only. It used to be generic over `customerType | customerSeriousness`;
// the seriousness half went with the rest of the retired legacy status vocabulary, and the
// lead status is now rendered by `ContactCrmStatusChip`. See docs/crm/crm-status-model.md.
type ContactTableCustomerChipProps = {
  type: "customerType";
  customerChipType: CustomerType;
};

export function ContactTableCustomerChip({
  customerChipType
}: ContactTableCustomerChipProps): JSX.Element {
  const { t: translate } = useTranslation();

  const mappedChipType: string | null =
    mappedCustomerTypes[customerChipType as keyof typeof mappedCustomerTypes] ?? null;

  const label = mappedChipType
    ? translate(`contactsPage.customerType.${mappedChipType}`)
    : customerChipType;

  const labelColor = customerTypeColors[customerChipType as keyof typeof customerTypeColors] ?? "default";

  return (
    <Label variant="ghost" color={labelColor}>
      {label}
    </Label>
  );
}

type CustomerTypeColors = Record<CustomerType, LabelColor>;

// Single source of truth for customer-type colors — every surface that shows a
// customer type (table chips, view modal, edit-modal sections/select) reads this map.
export const customerTypeColors: CustomerTypeColors = {
  מוכר: "primary",
  קונה: "secondary",
  שוכר: "success",
  משכיר: "warning",
  מתווך: "error",
  'עו"ד': "info",
  שמאי: "default"
};
